import btnGroup from './btnGroup.vue';
import pagination from './pagination.vue';
import modal from './modal.vue';
import inputmodal from './inputmodal.vue';
import formInput from './formInput.vue';
import formDateInput from './formDateInput.vue';
import formSelect from './formSelect.vue';
import formTextarea from './formTextarea.vue';
import fileUpload from './fileUpload.vue';
import query from './query.vue';

const install = function (Vue) {

    let components = {
        btnGroup: btnGroup,
        pagination: pagination,
        modal: modal,
        inputmodal: inputmodal,
        formInput: formInput,
        formDateInput: formDateInput,
        formSelect: formSelect,
        formTextarea: formTextarea,
        fileUpload: fileUpload,
        query: query
    };

    Object.keys(components).forEach(key => Vue.component(key, components[key]));
}

export default { install };